import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import { Paper, SpacingContainer } from '../../../components/common/Containers'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { InlineContainer } from '../../../components/common/Containers'
import Typography from '../../../components/common/Typography'
import { IconButton } from '@material-ui/core'
import EditIcon from '@mui/icons-material/Edit'
import { intlDateFormat } from '../../../utils/dateUtils'
import { makeStyles } from '@material-ui/core/styles'
import connect from '../connect'

const List = ({ rolesList, setRoleToEdit }) => {
  const navigate = useNavigate()
  const [arrayRoles, setArrayRoles] = useState([])

  useEffect(() => {
    if (Array.isArray(rolesList)) {
      setArrayRoles(rolesList)
    }
  }, [rolesList])

  const useStyles = makeStyles({
    tableText: {
      fontFamily: 'Manrope',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '19px',
    },
  })

  const textClasses = useStyles()

  const openDetail = (role) => {
    setRoleToEdit(role)
    navigate(`/role-editor/${role.key}`)
  }

  return (
    <TableContainer component={Paper} radius={9}>
      <SpacingContainer px="5sm3" py={2}>
        <Table style={{ minWidth: 1000 }}>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '20%' }} className={textClasses.tableText}>
                Created
              </TableCell>
              <TableCell align="left" style={{ width: '35%' }} className={textClasses.tableText}>
                Role
              </TableCell>
              <TableCell align="left" style={{ width: '35%' }} className={textClasses.tableText}>
                Users Assigned
              </TableCell>
              <TableCell align="right" style={{ width: '10%' }} className={textClasses.tableText} />
            </TableRow>
          </TableHead>
          <TableBody>
            {arrayRoles.map((role) => (
              <TableRow key={role.key}>
                <TableCell align="left" style={{ width: '20%' }}>
                  <InlineContainer>
                    <Typography className={textClasses.tableText}>
                      {intlDateFormat(role.createdAt)}
                    </Typography>
                  </InlineContainer>
                </TableCell>
                <TableCell align="left" style={{ width: '35%' }}>
                  <Typography className={textClasses.tableText}>{role.name}</Typography>
                </TableCell>
                <TableCell align="left" style={{ width: '35%' }}>
                  <Typography className={textClasses.tableText}>
                    {role?.count || 0}
                  </Typography>
                </TableCell>
                <TableCell align="right" style={{ width: '10%' }}>
                  <IconButton onClick={() => openDetail(role)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </SpacingContainer>
    </TableContainer>
  )
}

export default connect(List)
